<script>
	import { goto } from '$app/navigation';
	import { page } from '$app/stores';
	import { onMount } from 'svelte';
    import { Steps } from 'svelte-steps';
    let steps = [
        { text: 'Details' },
        { text: 'Payment' },
        { text: 'Order' }
    ];

    export let currentStepIndex
    

    function onStepChange(step) {
        const { current } = step.detail;
        const { last } = step.detail;
        
        console.log('current index: ', current);
        console.log('last index: ', last);

        switch (current) {
            case 0:
                goto('/checkout/step-one');
            break;
            case 1:
                goto('/checkout/step-two');
            break;
            default:
                goto('/checkout/step-one');
        }

    }
</script>

<div class="checkout-steps">
    <div class="container">
        <h1>Checkout</h1>

        <Steps {steps} 
            on:click={(e) => {
                e.preventDefault();
                // onStepChange(e)
            }}
            clickable={false}
            current={currentStepIndex}
            borderRadius="50%"
            primary="#ff0000" 
            secondary="#ffaaaa"
            size="2em" line="2px"    
        />
    </div>
</div>

<style lang="scss">
    .checkout-steps h1 {
        text-align: left;
    }
    .checkout-steps {
        max-width: 740px;
        width: 100%;
        margin: auto;
        .container-no--pad {
            padding: 0;
        }

        div {
            font-weight: 700;
            letter-spacing: 0.05em;
        }
    }
    
</style>